/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLocationsResponse } from '../../models/get-locations-response';

export interface GetAllLocations$Params {

/**
 * The page number.
 */
  page?: number;

/**
 * The size of a page.
 */
  size?: number;

/**
 * Sort order parameters.
 */
  sort?: string;

/**
 * Free text search term
 */
  search?: string;
}

export function getAllLocations(http: HttpClient, rootUrl: string, params?: GetAllLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllLocations.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLocationsResponse>;
    })
  );
}

getAllLocations.PATH = '/api/fbo/locations';
